import { Switch } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

const DynamicFieldSwitch = ({ value, onChange, ...props }) => {
  return <Switch checked={value} onChange={onChange} {...props} />;
};

DynamicFieldSwitch.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default memo(DynamicFieldSwitch);
